// Stamm-Mockdaten für das Dach-PV-Angebot.
// Werden durch die Sections konsumiert; alle Inhalte zentral an einer Stelle.

export const DACH_DATA = {
  kundenname: 'Mustermann GmbH',
  kundenadresse: 'Musterstraße 42, 12345 Musterstadt',
  angebotsnummer: 'AN-2025-0042',
  kundennummer: 'KD-1042',
  datum: '15. Januar 2025',
  gueltig_bis: '15. Februar 2025',
  dachflaeche: '1.250',
  kwp_leistung: '185',
  einmalige_auszahlung: '92.500',
  jaehrliche_auszahlung: '5.400',
  gesamte_pachtzahlung: '108.000',
  laufzeit: '20',
  vl_prozent: '20',
  ansprechpartner: 'Max Mustermann',
  telefonnummer: '+49 (0) 123 456 789',
  email: 'info@enpower.de',
  text: {
    cover: {
      badge: 'Indikationsangebot',
      eyebrow: 'Photovoltaik • Dachverpachtung',
      headline: 'IHR\nANGEBOT',
      sublinePrefix: 'Exklusiv erstellt für',
      projectAddressLabel: 'Projektadresse',
      confidentialNote:
        'Dieses Angebot ist vertraulich und wurde ausschließlich für den genannten Empfänger erstellt. · EN:POWER · info@enpower.de',
    },
    page2: {
      company: {
        header: {
          eyebrowSuffix: 'Unternehmensprofil',
          headline: 'SOLARENERGIE IST DIE ZUKUNFT',
        },
        intro: {
          paragraph1:
            'EN:POWER ist Ihr spezialisierter Partner für die wirtschaftliche Entwicklung von Photovoltaik-Projekten auf Dachflächen. Wir verbinden technische Expertise mit unternehmerischer Erfahrung - für Ergebnisse, die zählen.',
          paragraph2:
            'Von der ersten Anfrage bis zum laufenden Betrieb - alles aus einer Hand. Unsere Projekte reichen von Gewerbedachanlagen bis zu Multi-Megawatt-Projekten.',
        },
        quote: {
          quote: 'Ihr Dach arbeitet für Sie - ohne einen Cent eigener Investition.',
          footnote: 'EN:POWER übernimmt alles - Sie kassieren die Pacht.',
        },
        referenceLocations: {
          ref1: 'Hessen',
          ref2: 'NRW',
          ref3: 'Bayern',
        },
      },
      benefits: {
        header: {
          eyebrow: 'Was Sie gewinnen',
          headline: 'IHRE VORTEILE AUF EINEN BLICK',
        },
      },
    },
    page3: {
      project: {
        header: {
          eyebrow: 'Ihre Anlage',
          headline: 'IHR PACHTANGEBOT',
        },
        addressLabel: 'Projektadresse:',
        addressTextPrefix: '',
        addressTextSuffix: '- Analysierte Leistung:',
        intro:
          'Die Voranalyse Ihrer angegebenen Dachflächen ergab, vorbehaltlich einer Vor-Ort-Besichtigung, folgende Eckdaten:',
        processLabel: 'Ablauf des Projekts',
      },
    },
    pricing: {
      header: {
        eyebrow: 'Persönliches Angebot',
        headline: 'IHRE PREISOPTIONEN',
      },
      meta: {
        auftraggeberLabel: 'Auftraggeber',
        angebotsnummerLabel: 'Angebots-Nr.',
        angebotstypLabel: 'Angebotstyp',
        angebotstypValue: 'Pachtzahlung - indikativ',
      },
      option1: {
        headerLabel: 'Option 1 - Einmalzahlung',
        headerSub: 'Einmalige Auszahlung bei Vertragsabschluss',
        priceLabel: 'Einmalige Auszahlung',
        priceFootnote: 'netto zzgl. MwSt.',
        rows: {
          auszahlung: 'Auszahlung',
          laufzeit: 'Laufzeit',
          nachVerlaengerung: 'Nach Verlängerung',
          anlageNachLaufzeit: 'Anlage nach Laufzeit',
          kostenFuerSie: 'Kosten für Sie',
        },
      },
      option2: {
        headerLabel: 'Option 2 - Jährlich',
        headerSub: 'Jährliche Pacht über die gesamte Laufzeit',
        priceLabel: 'Jährliche Auszahlung',
        priceFootnote: 'netto zzgl. MwSt. / Jahr',
        rows: {
          gesamtePachtzahlung: 'Gesamte Pachtzahlung',
          laufzeit: 'Laufzeit',
          nachVerlaengerung: 'Nach Verlängerung',
          anlageNachLaufzeit: 'Anlage nach Laufzeit',
          kostenFuerSie: 'Kosten für Sie',
        },
      },
      values: {
        auszahlungVoraus: 'für 20 Jahre im Voraus',
        laufzeitSuffix: 'Jahre + Opt. 2x5 J.',
        nachVerlaengerungPrefix: 'Ertragsbeteiligung',
        anlageNachLaufzeit: 'Kostenfreie Übernahme möglich',
        kostenFuerSie: 'Null €',
      },
      notice:
        'Alle Angaben sind indikativ und vorbehaltlich einer Vor-Ort-Besichtigung, eines exakten Aufmaßes und der Netzrückmeldung. EN:POWER trägt alle Kosten für Planung, Installation, Betrieb und Versicherung der Anlage.',
    },
    alternatives: {
      header: {
        eyebrow: 'Weitere Möglichkeiten',
        headline: 'ALTERNATIVEN ZUR DACHVERMIETUNG',
      },
      option1: {
        title: 'Direktkauf Ihrer Dachfläche',
        description:
          'EN:POWER kauft Ihre Dachfläche direkt - Sie erhalten eine sofortige Einmalzahlung und behalten alle Eigentumsrechte.',
        hint: 'Maximale Einmalzahlung',
      },
      option2: {
        title: 'Persönliche Beratung',
        description:
          'In einem persönlichen Gespräch analysieren wir gemeinsam, welche Option optimal zu Ihrer Situation passt.',
        hint: 'Kostenlose Erstberatung',
      },
    },
    page4: {
      nextSteps: {
        header: {
          eyebrow: 'Ihr Weg zu sicheren Pachteinnahmen',
          headline: "SO GEHT'S WEITER",
        },
      },
      faq: {
        header: {
          eyebrow: 'Häufige Fragen',
          headline: 'HABEN SIE NOCH FRAGEN?',
        },
      },
      cta: {
        badge: 'Bereit für den nächsten Schritt?',
        headline: 'Lassen Sie uns sprechen.',
        sublinePrefix: 'Ich freue mich auf Ihre Rückmeldung -',
        signatureLead: 'Mit freundlichen Grüßen,',
        validUntilLabel: 'Gültig bis',
      },
    },
  },
};
